import React from 'react';
import { Autocomplete, Dialog, DialogActions, DialogContent, Skeleton, TextField } from '@mui/material';
import CustomButton from '../../../components/buttons/CustomButton';
import { roundedFieldSx } from './budgetFormat';
import styles from './BudgetDialogs.module.css';

export const dialogPaperProps = { className: styles.paper };

/** Cabeçalho dos diálogos do orçamento: ícone, título e uma linha de apoio. */
export function DialogHeader({ icon, title, subtitle }) {
  return (
    <div className={styles.header}>
      <span className={styles.icon}>{icon}</span>
      <div className={styles.titleBlock}>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <span className={styles.subtitle}>{subtitle}</span>}
      </div>
    </div>
  );
}

/**
 * Escolha de um procedimento ou pacote para virar item do orçamento.
 * "Adicionar" só liga com uma opção escolhida (e, no pacote, depois de carregar).
 */
function BudgetPickerDialog({
  open, onClose, icon, title, subtitle, inputLabel, noOptionsText,
  options, getOptionLabel, value, onChange, loading = false, onConfirm,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={dialogPaperProps}>
      <DialogHeader icon={icon} title={title} subtitle={subtitle} />
      <DialogContent className={styles.content}>
        {loading ? (
          <Skeleton variant="rounded" height={40} className={styles.skeleton} />
        ) : (
          <Autocomplete
            options={options}
            getOptionLabel={getOptionLabel}
            value={value}
            onChange={(_, next) => onChange(next)}
            renderInput={(params) => (
              <TextField {...params} label={inputLabel} size="small" fullWidth autoFocus sx={roundedFieldSx} />
            )}
            noOptionsText={noOptionsText}
          />
        )}
      </DialogContent>
      <DialogActions className={styles.actions}>
        <CustomButton label="Cancelar" style="primary" variant="outlined" onClick={onClose} />
        <CustomButton
          label="Adicionar"
          style="primary"
          variant="contained"
          enabled={!!value && !loading}
          onClick={onConfirm}
        />
      </DialogActions>
    </Dialog>
  );
}

export default BudgetPickerDialog;
